import React from 'react';
import clsx from 'clsx';
import Skeleton from 'react-loading-skeleton';
import featureStyles from '../FeatureHighlight/FeatureHighlight.module.css';
import sharedStyles from '../Products.module.css';
import styles from './ProductsSkeleton.module.css';

export const ProductsSkeleton = () => {
  const renderFeatures = () => {
    const feature = (
      <div className={featureStyles.featureHighlight}>
        <Skeleton
          circle
          className={styles.featureIcon}
          baseColor="var(--color-secondary-90)"
        />
        <Skeleton
          containerClassName={styles.featureWrapper}
          className={styles.featureText}
          baseColor="var(--color-secondary-80)"
        />
      </div>
    );

    return (
      <div className={clsx(sharedStyles.highlights, styles.highlights)}>
        {feature}
        {feature}
        {feature}
      </div>
    );
  };

  return (
    <div
      className={sharedStyles.container}
      data-testid="products-skeleton-loader"
    >
      <div className={styles.tableSection}>
        <Skeleton
          className={styles.title}
          baseColor="var(--color-secondary-80)"
        />

        <Skeleton
          className={styles.subTitle}
          baseColor="var(--color-secondary-80)"
        />

        {renderFeatures()}

        <div className={styles.table}>
          <Skeleton
            containerClassName={styles.leadingColumn}
            className={styles.column}
            baseColor="var(--color-secondary-90)"
          />
          <Skeleton
            containerClassName={styles.column}
            className={styles.column}
            baseColor="var(--color-structure-100)"
          />
          <Skeleton
            containerClassName={styles.column}
            className={styles.column}
            baseColor="var(--color-structure-100)"
          />
          <Skeleton
            containerClassName={styles.column}
            className={styles.column}
            baseColor="var(--color-structure-100)"
          />
        </div>
      </div>
    </div>
  );
};
